import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "../IntegrationStore";
import { alert } from "../../general/alertStore.js";
import IntegrationTrigger from "../IntegrationTrigger";

import axios from "../../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../../general/ApplicationContext";
import { Input, FormGroup, Label } from "../../components/Modal";
import { ADAMIntegration } from "./ADAMStore.js";


interface ADAMState {
    profiles: Array<ADAMIntegration>;
    users: any;
    selectedProfile: ADAMIntegration;
    selectedProfileId: string;
    syncResult: any;
}

interface ADAMProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class ImportADAMStudents extends Component<ADAMProps, ADAMState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new ADAMIntegration(),
            selectedProfileId: "",
            syncResult: undefined,
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 0; //In
                    prevState.selectedProfile.integrationType = 4; //ADAM
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    loadUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/GetADAMUsers`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: "alert-success",
                    text: `Users synced successfully`,
                });
                this.setState({ syncResult: response.data });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    syncUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ImportUsersFromADAM`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: "alert-success",
                    text: `Users synced successfully`,
                });
                this.setState({ syncResult: response.data });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/4?organizationId=${this.props.organization}`) //ADAM
            .then((response) => {
                this.setState({ profiles: response.data, selectedProfile: new ADAMIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new ADAMIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handlePriorityChange = (e) => {
      let priority = e.target.valueAsNumber;
      this.setState((prevState) => {
          prevState.selectedProfile.priority = priority;
          return prevState;
      });
  };

    handleADAMUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handleApiKeyChange = (e) => {
        let apiKey = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.apiKey = apiKey;
            return prevState;
        });
    };

    handleUsernameChange = (e) => {
        let username = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.username = username;
            return prevState;
        });
    };

    handlePasswordChange = (e) => {
        let password = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.password = password;
            return prevState;
        });
    };

    handleDomainChange = (e) => {
        let domain = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.domain = domain;
            return prevState;
        });
    };

    render() {
        return (
            <div className="space-y-6">
                <h3 className="text-2xl font-semibold text-gray-900">ADAM Users</h3>

                <div className="space-y-6">
                    <FormGroup>
                        <Label htmlFor="profile">Profile</Label>
                        <Input type="select" id="profile" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                            <option>Please Select</option>
                            {this.state.profiles.map((profile) => (
                                <option key={profile.integrationId} value={profile.integrationId}>
                                    {profile.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>

                    {this.state.selectedProfileId && (
                        <div>
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormGroup>
                            <Label htmlFor="profileName">Profile Name</Label>
                            <Input type="text" id="profileName" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                        </FormGroup>

                        {this.state.selectedProfileId && (
                            <FormGroup>
                                <Label htmlFor="priority">Priority (lower first)</Label>
                                <Input type="number" id="priority" value={this.state.selectedProfile.priority} onChange={this.handlePriorityChange} />
                            </FormGroup>
                        )}

                        {!this.state.selectedProfileId && (
                            <div className="flex items-end justify-end">
                                <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                    Create Profile
                                </button>
                            </div>
                        )}
                    </div>

                    {this.state.selectedProfileId && (
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormGroup>
                                    <Label htmlFor="adamUrl">ADAM URL</Label>
                                    <Input type="text" id="adamUrl" value={this.state.selectedProfile.config.url} onChange={this.handleADAMUrlChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="domain">Domain</Label>
                                    <Input type="text" id="domain" value={this.state.selectedProfile.config.domain} onChange={this.handleDomainChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="apiKey">API Key</Label>
                                    <Input type="text" id="apiKey" value={this.state.selectedProfile.config.apiKey} onChange={this.handleApiKeyChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="username">Username</Label>
                                    <Input type="text" id="username" value={this.state.selectedProfile.config.username} onChange={this.handleUsernameChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="password">Password</Label>
                                    <Input type="text" id="password" value={this.state.selectedProfile.config.password} onChange={this.handlePasswordChange} />
                                </FormGroup>

                                <div className="flex items-end justify-end">
                                    <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                        Save Profile
                                    </button>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2">
                                <button className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.loadUsers}>
                                    Load
                                </button>
                                <button className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.syncUsers}>
                                    Sync
                                </button>
                            </div>

                            {this.state.syncResult && (
                                <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                                    <a href={`/hangfire/jobs/details/${this.state.syncResult}`} className="text-blue-600 hover:text-blue-800 underline">
                                        Background Job Created
                                    </a>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
